module.exports = __webpack_public_path__ + "static/media/shoe.e7d4a8a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shoe.svg
// module id = 667
// module chunks = 0